module.exports = __webpack_public_path__ + "static/media/S (82).2f9cbfe5.jpg";